import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Paper elevation={3} sx={{ p: 5, borderRadius: 4 }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: '#4caf50', mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight="bold">
          You're all set!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Your subscription has been successfully activated. Thank you for joining Pelican Beaks Premium!
        </Typography>
        <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
          Redirecting you to your dashboard in a few seconds...
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          size="large"
          onClick={() => navigate('/dashboard')}
          sx={{ borderRadius: 2, px: 4 }}
        >
          Go to Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default SubscriptionSuccess;

